import React, { useCallback, useState } from 'react';
import Slider from 'react-slick';
import cn from 'classnames';

import ExternalLink from 'components/generic/ExternalLink.component';
import CONF from 'config/conf.singleton';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import { trackEvent } from 'tracking/actions';

import CN from './SlickSlider.module.scss';

const LINK_TIPPING = 'https://www.getslick.com/tipping';
const LINK_REF = 'https://www.getslick.com/referral';
const MARKETING_SITE_TAS = `${CONF.marketingSite}/terms-and-conditions`;

const SlickSlider = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const { t } = useTranslation();

  const handleAfterChange = useCallback((index) => {
    setActiveSlide(index);
  }, []);

  const customPaging = useCallback(
    (index) => (
      <span
        className={cn({
          [CN.dot]: true,
          [CN.active]: index === activeSlide,
        })}
        onClick={() => handleAfterChange(index)}
      />
    ),
    [activeSlide, handleAfterChange],
  );

  return (
    <Slider
      dots
      dotsClass={CN.slickDots}
      customPaging={customPaging}
      arrows={false}
      infinite
      fade
      speed={1000}
      autoplay
      autoplaySpeed={4000}
      slidesToShow={1}
      slidesToScroll={1}
      afterChange={handleAfterChange}
      className={cn({
        [CN.component]: true,
      })}
    >
      <div
        data-bem="SlickSlider__email"
        className={cn({
          [CN.slideImage]: true,
          [CN.imageEmail]: true,
        })}
      >
        <div className={CN.container}>
          <div className={CN.description}>
            <div className={CN.subTitle}>
              <div className={CN.text}>
                {S.email} {t('composite.slickSlider.slide1.title')}
              </div>
            </div>
            <div className={CN.title}>
              {t('composite.slickSlider.slide1.description.part1')}
              {S.space}
              <div className={CN.textWave}>{t('composite.slickSlider.slide1.description.part2')}</div>
            </div>
          </div>
        </div>
      </div>

      <div
        data-bem="SlickSlider__reff"
        className={cn({
          [CN.slideImage]: true,
          [CN.imageReff]: true,
        })}
      >
        <div className={CN.container}>
          <div className={CN.description}>
            <div className={CN.subTitle}>
              <span className={CN.emoji}>{S.womanRaisingHand}</span>
              <div className={CN.text}>{t('composite.slickSlider.slide2.title')}</div>
            </div>
            <div className={CN.title}>
              {t('composite.slickSlider.slide2.description.part1')}
              {S.space}
              <div className={CN.textWave}>{t('composite.slickSlider.slide2.description.part2')}</div>
            </div>
            <div className={CN.linkContainer}>
              <ExternalLink variant="tertiaryLight" link={LINK_REF} onClick={() => trackEvent('login_vouchers')}>
                <div className={CN.link}>{t('composite.slickSlider.slide2.referFriendButton')}</div>
              </ExternalLink>
              <a href={MARKETING_SITE_TAS} className={CN.tAndC}>
                <span>{t('composite.slickSlider.slide2.termsAndConditions')}</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        data-bem="SlickSlider__tipping"
        className={cn({
          [CN.slideImage]: true,
          [CN.imageTipping]: true,
        })}
      >
        <div className={CN.container}>
          <div className={CN.description}>
            <div className={CN.subTitle}>
              <div className={CN.text}>
                {S.poundBanknote} {t('composite.slickSlider.slide3.title')}
              </div>
            </div>
            <div className={CN.title}>
              {t('composite.slickSlider.slide3.description.part1')}
              {S.space}
              <div className={CN.textWave}>{t('composite.slickSlider.slide3.description.part2')}</div>
            </div>
            <div className={CN.linkContainer}>
              <ExternalLink variant="tertiaryLight" link={LINK_TIPPING} onClick={() => trackEvent('login_education')}>
                <div className={CN.link}>{t('composite.slickSlider.slide3.learnMoreButton')}</div>
              </ExternalLink>
            </div>
          </div>
        </div>
      </div>
    </Slider>
  );
};

export default SlickSlider;
